import { useDeleteDeviceMutation } from '@/graphql/types';

export default function (device: { id: string }) {
  const mutation = useDeleteDeviceMutation({});

  function call() {
    return mutation.mutate({
      id: device.id
    });
  }

  return {
    ...mutation,
    call
  };
}
